export default __webpack_public_path__ + "static/roundringtube-fc753668c86606881aadba7fcab23cf1.png";